<div class="ws-step">
  <div class="ws-step-header">
    <h3>Call Outcomes</h3>
    <p class="text-muted">When your salespersons call leads, they choose a call outcome after each connected call. You can add, remove, or edit — here are smart suggestions based on your business.</p>
  </div>

  <div class="ws-step-body">
    <!-- Positive outcomes -->
    @if (positiveOutcomes.length) {
      <h6 class="mb-2"><span class="ws-chip ws-chip-positive">Positive</span></h6>
      <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'positive')">
        @for (outcome of positiveOutcomes; track outcome.value) {
          <div class="ws-item-card ws-card-positive" [ngClass]="{'selected': outcome.selected}" cdkDrag>
            <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
            <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-positive" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
            <div class="ws-item-content">
              <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
              <div class="ws-option-toggle">
                <span class="ws-toggle-switch" [ngClass]="{'active': outcome.startsNewDeal}" (click)="outcome.startsNewDeal = !outcome.startsNewDeal"></span>
                <span>Auto-create a deal when rep selects this outcome</span>
              </div>
            </div>
            <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
          </div>
        }
      </div>
    }

    <!-- Neutral outcomes -->
    @if (neutralOutcomes.length) {
      <h6 class="mb-2 mt-3"><span class="ws-chip ws-chip-neutral">Neutral</span></h6>
      <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'neutral')">
        @for (outcome of neutralOutcomes; track outcome.value) {
          <div class="ws-item-card ws-card-neutral" [ngClass]="{'selected': outcome.selected}" cdkDrag>
            <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
            <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-neutral" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
            <div class="ws-item-content">
              <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
            </div>
            <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
          </div>
        }
      </div>
    }

    <!-- Negative outcomes -->
    @if (negativeOutcomes.length) {
      <h6 class="mb-2 mt-3"><span class="ws-chip ws-chip-negative">Negative</span></h6>
      <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'negative')">
        @for (outcome of negativeOutcomes; track outcome.value) {
          <div class="ws-item-card ws-card-negative" [ngClass]="{'selected': outcome.selected}" cdkDrag>
            <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
            <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-negative" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
            <div class="ws-item-content">
              <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
              <div class="ws-item-meta" style="color: #e53935;">
                <i class="bi bi-info-circle me-1"></i>Lead will be closed automatically when this outcome is selected
              </div>
            </div>
            <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
          </div>
        }
      </div>
    }

    @if (!outcomes.length) {
      <div class="ws-empty-state">
        <i class="bi bi-telephone"></i>
        <p>No call outcomes suggested. Add your own or provide a business description.</p>
      </div>
    }

    <!-- Add new outcome -->
    <div class="d-flex align-items-center gap-2 mt-3">
      <input class="form-control form-control-sm" [(ngModel)]="newOutcomeName" placeholder="Add new outcome..." (keyup.enter)="addOutcome()" />
      <select class="form-select form-select-sm" style="width: 120px;" [(ngModel)]="newOutcomeNature">
        <option value="positive">Positive</option>
        <option value="neutral">Neutral</option>
        <option value="negative">Negative</option>
      </select>
      <button class="btn btn-sm btn-outline-primary" (click)="addOutcome()" [disabled]="!newOutcomeName.trim()">Add</button>
    </div>

    <!-- Feedback section -->
    <div class="ws-feedback-section">
      <div class="ws-feedback-label">Want different outcomes? Describe what you need:</div>
      <textarea [(ngModel)]="feedback" placeholder="e.g. We need outcomes for loan applications — approved, rejected, documents pending, etc."></textarea>
      <div class="ws-feedback-actions">
        <button class="btn btn-sm btn-outline-primary" (click)="submitFeedback()" [disabled]="!feedback.trim()">
          <i class="bi bi-stars me-1"></i> Regenerate with AI
        </button>
      </div>
    </div>

    <div class="ws-save-row">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Save & Continue
      </button>
    </div>
  </div>
</div>
